import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import SuccessScreen from '../Common/SuccessScreen';

const Success = () => {
    const { t } = useTranslation();
    const history = useHistory();

  return (
    <div
      className='payment-confirm-container '
      style={{ paddingBottom: 'calc(70px + env(safe-area-inset-bottom))' }}
    >
      <SuccessScreen
          title={t('accountSuccessActivated.title')}
          subtitle={t('accountSuccessActivated.subtitle')}
          path={'/'}
        />
    </div>
  );
};

export default Success;
